import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { GALLERY } from "@/lib/site";

const origin = API.replace(/\/api$/, "");
const fullUrl = value => value?.startsWith("/api/") ? `${origin}${value}` : value;

export default function useWorkJobs(slug) {
    const [imported, setImported] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        let cancelled = false;
        const specific = slug?.startsWith("instagram-");
        axios.get(specific ? `${API}/work/${encodeURIComponent(slug)}` : `${API}/work`).then(({ data }) => {
            const list = specific ? [data] : data;
            if (!cancelled) setImported(list.map(job => ({ ...job, image: fullUrl(job.image), cover: fullUrl(job.cover), workPhotos: job.workPhotos.map(fullUrl) })));
        }).catch(() => { if (!cancelled) setError(true); }).finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [slug]);
    return { jobs: [...imported, ...GALLERY], loading, error };
}